// Pure, dependency-free helpers for the units-change loading indicator.
// Shared by web (Header) and mobile (useUnitsRecalcObserver) — keep platform-agnostic.

const UNITS_LOADING_TIMEOUT_MS = 60000;

const isHistoryFinished = (hadSelected, status, sawInit) => {
  if (!hadSelected) {
    return true;
  }
  return sawInit && status !== 'init';
};

const shouldStopUnitsLoading = ({
  unitsLoading,
  setUserAttributesFlowState,
  farmingUnitLoadHistoryStatus,
  fieldLoadHistoryStatus,
  hadFieldSelected,
  hadFarmingUnitSelected,
  farmingUnitSawInit,
  fieldSawInit,
}) => {
  if (!unitsLoading) {
    return false;
  }

  const putFinished =
    setUserAttributesFlowState === 'success' ||
    setUserAttributesFlowState === 'fail';
  const farmingUnitFinished = isHistoryFinished(
    hadFarmingUnitSelected,
    farmingUnitLoadHistoryStatus,
    farmingUnitSawInit
  );
  const fieldFinished = isHistoryFinished(
    hadFieldSelected,
    fieldLoadHistoryStatus,
    fieldSawInit
  );

  return putFinished && farmingUnitFinished && fieldFinished;
};

module.exports = {
  UNITS_LOADING_TIMEOUT_MS,
  isHistoryFinished,
  shouldStopUnitsLoading,
};
